module.exports = __webpack_public_path__ + "media/images/brand/discover-a382bb30c32ca5d8c03fc916ee2a70f7.png";